import { parseNumericInput } from './priceListProductCalculator';

const EQUAL_EPSILON = 0.001;
/** Half of one hundredth of a percent, so values that display the same match. */
const DISPLAY_EQUAL_EPSILON = 0.00005;

function hasPercentValue(percentRaw) {
    return percentRaw !== null
        && percentRaw !== undefined
        && String(percentRaw).trim() !== '';
}

/**
 * Compare adaos actual with adaos de referință.
 * Values are ratios (0.30 = 30%). An empty threshold means any strict
 * difference. A filled threshold is percentage points: 5 with „mai mic”
 * keeps markups at least 5 points below the reference (30% → 25% or less).
 *
 * @param {unknown} actualRaw
 * @param {unknown} referenceRaw
 * @param {'lt'|'gt'|'eq'} op
 * @param {unknown} percentRaw
 * @returns {boolean}
 */
export function matchesMarkupVsReference(actualRaw, referenceRaw, op, percentRaw) {
    if (op !== 'lt' && op !== 'gt' && op !== 'eq') {
        return false;
    }
    if (
        actualRaw === null
        || actualRaw === undefined
        || actualRaw === ''
        || referenceRaw === null
        || referenceRaw === undefined
        || referenceRaw === ''
    ) {
        return false;
    }

    const actual = parseNumericInput(actualRaw);
    const reference = parseNumericInput(referenceRaw);
    if (!Number.isFinite(actual) || !Number.isFinite(reference)) {
        return false;
    }

    if (!hasPercentValue(percentRaw)) {
        if (op === 'eq') {
            return Math.abs(actual - reference) <= DISPLAY_EQUAL_EPSILON;
        }
        if (op === 'lt') {
            return actual < reference - EQUAL_EPSILON;
        }
        return actual > reference + EQUAL_EPSILON;
    }

    const points = parseNumericInput(percentRaw);
    if (!Number.isFinite(points)) {
        return false;
    }
    const delta = points / 100;
    const epsilon = 1e-9;
    if (op === 'eq') {
        return Math.abs(actual - reference) <= DISPLAY_EQUAL_EPSILON
            && Math.abs(actual - delta) <= DISPLAY_EQUAL_EPSILON;
    }
    if (op === 'lt') {
        return reference - actual + epsilon >= delta;
    }
    return actual - reference + epsilon >= delta;
}
